import { marketPeriodHelper } from "app/helpers/marketPeriodHelper";
import type { EventRunnerType, EventType } from "app/types/eventType";
import RenderOddsComponent from "../../../RenderOddsComponent/RenderOddsComponent";
import "../../HomeAwaySides.scss";

export default function HomeAwaySidesRunner(props: {
  event: EventType;
  runner: EventRunnerType;
  side: string;
  addBetSlip: Function;
}) {
  const { event, runner, side, addBetSlip } = props;

  return (
    <span
      key={"home-and-away-sides" + runner.id}
      onClick={() => {
        addBetSlip(runner);
      }}
      className={`home-and-away-sides__runner ${side}`}
    >
      <div className={"runner__name"}>
        {marketPeriodHelper.formatRunnerName(runner.name)}
      </div>
      <RenderOddsComponent event={event} runner={runner} />
    </span>
  );
}
